<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Samen aangifte doen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Samen aangifte doen, betekent dat je in deze aangifte de gegevens van aangever én die van de fiscale
                partner invult. De kans op fouten is dan kleiner, omdat de gegevens van de partners in dezelfde aangifte
                staan. Dat is voor de Belastingdienst ook prettig, want zij hoeven eventuele fouten dan niet achteraf te
                corrigeren.

                <div class="space10"></div>
                <b>Aftrekposten onderling verdelen</b><br/>
                Als fiscale partners mag je gezamenlijke inkomsten en aftrekposten onderling verdelen. Je kunt dan
                bijvoorbeeld (een deel van) een aftrekpost toekennen aan degene met het hoogste inkomen. Je krijgt dan
                in de regel meer belasting terug. Ons programma helpt je hiermee door de meest optimale verdeling voor
                je te berekenen.
                <div class="space10"></div>
                Onderling verdelen doe je aan het einde van de aangifte (in het scherm Verdeling), nadat je alle
                inkomsten en aftrekposten hebt ingevuld. Als je samen aangifte doet, kunt je nooit te veel verdelen
                tussen de partners. Je wordt hiermee dan geholpen in de aangifte tijdens het invullen.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Afzonderlijk aangifte doen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Let op! De optie om als fiscaal partners afzonderlijk aangifte te doen wordt nu nog niet ondersteund door Snelstart Fiscaal.</b>
                <div class="space10"></div>
                De meeste mensen doen samen aangifte. Als je niet in de gelegenheid bent om de aangifte voor aangever
                en partner samen te doen, kun je ook apart aangifte doen. Je vult dan - zowel in de aangifte als in de
                aangifte van de partner - het totaalbedrag van de gezamenlijke aftrekpost of inkomsten in.
                <div class="space10"></div>
                Let erop dat je e.e.a. afstemt wat een ieder in de aangifte invult in het verdeelscherm, zodat de
                aangiften met elkaar overeenkomen en het totaalbedrag van de verdeling niet meer dan 100% is. Dat lijkt logisch, maar dat gaat in de praktijk helaas
                regelmatig mis.
                <div class="space10"></div>
                Als je er niet voor kiest gezamenlijk aangifte te doen, dan wordt het arbeidsinkomen en verzamelinkomen
                van de partner uitgevraagd. Dat is nodig voor o.a. het berekenen van drempels en heffingskortingen.
            </div>
        </div>
    </div>

</div>

